import { render, staticRenderFns } from "./FormAccordion.vue?vue&type=template&id=5bc1a0ed&scoped=true&"
import script from "./FormAccordion.vue?vue&type=script&lang=js&"
export * from "./FormAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FormAccordion.vue?vue&type=style&index=0&id=5bc1a0ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1a0ed",
  null
  
)

export default component.exports